<template>
  <div style="padding: 20px; background: #F1F2F5">
    <!-- tabs 栏 -->
    <div style="background-color: #FFFFFF;padding: 20px">
      <div class="search-container">
        <input
          v-model="keyword"
          type="text"
          placeholder="搜索产品名/短剧名/公司名/文案"
          class="search-input"
        >
        <button
          class="search-button"
          @click="search"
        >
          <i class="el-icon-search" />
        </button>
      </div>
      点赞数
      <el-select v-model="query.like_count" style="width: 150px;margin: 10px">
        <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      评论数
      <el-select v-model="query.comment_count" style="width: 150px;margin: 10px">
        <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      分享数
      <el-select v-model="query.share_count" style="width: 150px;margin: 10px">
        <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      收藏数
      <el-select v-model="query.favorite_count" style="width: 150px;margin: 10px">
        <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      热度值
      <el-select v-model="query.heat" style="width: 150px;margin: 10px">
        <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <!-- 投放类型
      <el-select v-model="type" placeholder="请选择投放类型" @change="handleChange">
        <el-option label="全部" value="all" />
        <el-option label="IAA模式" value="iaa" />
        <el-option label="IAP模式" value="iap" />
      </el-select> -->
      <!-- <div>
        <p>iaa: {{ query.iaa }}</p>
        <p>iap: {{ query.iap }}</p>
      </div> -->
      <!--      <el-form-->
      <!--        label-width="100px"-->
      <!--        style="margin-top: 20px"-->
      <!--      >-->
      <!--        <el-form-item label="排序方式">-->
      <!--          <div>-->
      <!--&lt;!&ndash;            <el-tag&ndash;&gt;-->
      <!--&lt;!&ndash;              v-for="item in slot_option"&ndash;&gt;-->
      <!--&lt;!&ndash;              :key="item.value"&ndash;&gt;-->
      <!--&lt;!&ndash;              style="margin-right: 20px"&ndash;&gt;-->
      <!--&lt;!&ndash;              :type="slot_value === item ? 'primary' : 'info'"&ndash;&gt;-->
      <!--&lt;!&ndash;              effect="plain"&ndash;&gt;-->
      <!--&lt;!&ndash;              @click="checkSlot(item)"&ndash;&gt;-->
      <!--&lt;!&ndash;            >&ndash;&gt;-->
      <!--&lt;!&ndash;              {{ item.label }}&ndash;&gt;-->
      <!--&lt;!&ndash;            </el-tag>&ndash;&gt;-->
      <!--          </div>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->
    </div>
    <div class="line" />

    <div class="sticky-header">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-checkbox
            :indeterminate="isIndeterminate"
            :checked="isChecked"
            @change="handleToggleAll"
          >
            全选
          </el-checkbox>
          <el-tag
            style="margin-left: 5px"
            closable
            @close="handleToggleAll(false)"
          >
            已选{{ selectedItems.length }}
          </el-tag>
        </div>
        <el-button
          type="success"
          icon="el-icon-download"
          :disabled="!selectedItems.length"
          @click="downloadMaterial"
        >下载</el-button>
      </div>
    </div>
    <!-- 数据展示区域 -->
    <div style="display: flex;flex-wrap: wrap">
      <div
        v-for="(item, index) in table_data"
        :key="index"
        style="width: 438px;height: 312px;margin: 10px 8px;background-color: #FFFFFF;border-radius: 5px;border: 1px solid rgb(240, 242, 245);"
      >
        <div
          style="height: 48px;display: flex;justify-content: space-between;padding: 10px 15px;cursor: pointer;"
          @click.stop="selectTab(item)"
        >
          <div style="display: flex;align-items: center;">
            <div style="flex-direction: column;justify-content: center;align-items: center;margin-left: 10px">
              <div style="margin-bottom:7px;font-weight:600;font-size:16px">{{ item.miniseries_name }}</div>
            </div>
          </div>
          <div style="text-align: end">
            <el-checkbox
              style="pointer-events: none"
              :value="selectedItems.includes(item)"
              @click.native.stop
            />
            <div style="margin-top: 8px;font-size: 12px;max-width: 204px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.publisher_name }}</div>
          </div>
        </div>

        <div
          style="cursor: pointer;position: relative;"
          @click="itemInfo(item)"
        >
          <el-image
            :src="item.cover_url"
            referrerpolicy="no-referrer"
            style="width: 436px;height: 180px"
            fit="cover"
          />
          <div style="position: absolute;bottom:0px;left:0px;display: flex;background-color: rgba(0, 0, 0, 0.3);padding: 10px 30px;width: 100%;justify-content: space-between;">
            <div>
              <img
                style="width:20px;height:20px;margin-right:5px"
                src="@/assets/images/adx/favorite.png"
                alt=""
                srcset=""
              >
              <span style="color:white">{{ item.favorite_count }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/like.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.like_count }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/comment.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.comment_count }}</span>
            </div>
            <div> <img
                    style="width:20px;height:20px;margin-right:5px"
                    src="@/assets/images/adx/forward.png"
                    alt=""
                    srcset=""
                  >
              <span style="color:white">{{ item.share_count }}</span>
            </div>
          </div>
        </div>
        <div
          style="height: 154px;padding: 20px 0;cursor: pointer"
          @click="itemInfo(item)"
        >
          <div style="height: 30px; font-size: 16px; line-height: 25px; padding: 0 20px;">
            <div
              style="color: #1D2129;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"
              v-html="item.title"
            />
          </div>
        </div>
      </div>
    </div>

    <pagination-right
      :total="total"
      :page-sizes="[30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :visible.sync="info_visible"
      :destroy-on-close="true"
      width="1000px"
      title="素材详情"
    >
      <Info ref="matinfo" />
    </el-dialog>
  </div>
</template>

<script>
import { materialInfoList } from '@/api/report/dxj'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Info from '../components/info.vue'
export default {
  components: { PaginationRight, Info },
  data() {
    return {
      query: {
        page: 1,
        page_size: 30,
        playlet_id: null,
        like_count: null,
        comment_count: null,
        share_count: null,
        favorite_count: null,
        heat: null,
        iaa: null,
        iap: null
      },
      total: 0,
      table_data: [],
      keyword: null,
      currentFetchMethod: null,
      info_visible: false,
      selectedItems: [],
      slot_option: [
        { label: '点赞数', value: '1' },
        { label: '评论数', value: '2' },
        { label: '分享数', value: '3' },
        { label: '收藏数', value: '4' },
        { label: '热度值', value: '5' }
      ],
      option: [
        { label: '最少', value: 1 },
        { label: '最多', value: 2 }
      ],
      slot_value: null,
      type: 'all'
    }
  },
  computed: {
    isChecked() {
      const list = this.material_data?.list || []
      return list.length > 0 && this.selectedItems.length === list.length
    },
    isIndeterminate() {
      const list = this.material_data?.list || []
      return this.selectedItems.length > 0 && this.selectedItems.length < list.length
    }
  },
  created() {
    console.log(this.query)
    // 初始化查询参数
    this.query.miniseries_id = this.$route.query.miniseries_id || null
    this.list()
  },
  methods: {
    list() {
      materialInfoList(this.query).then(res => {
        this.table_data = res.data.list
        this.total = res.data.total
      })
    },
    addStrategy() {

    },
    linkToInfo(val) {
      console.log(val)
    },
    search() {
      this.list()
    },
    selectTab(val) {
      const index = this.selectedItems.indexOf(val)
      if (index === -1) {
        this.selectedItems.push(val)
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    fetchPageSize(data) {
      this.query.page_size = data
      if (this.currentFetchMethod === 'list') {
        this.list()
      } else if (this.currentFetchMethod === 'moreList') {
        this.moreList()
      }
    },
    fetchCurrentPage(data) {
      this.query.page = data
      if (this.currentFetchMethod === 'list') {
        this.list()
      } else if (this.currentFetchMethod === 'moreList') {
        this.moreList()
      }
    },
    itemInfo(val) {
      console.log(val)
      this.info_visible = true
      this.$nextTick(() => {
        this.$refs.matinfo.send(val)
      })
    },
    handleToggleAll(val) {
      if (val) {
        this.selectedItems = this.generateAllItems()
      } else {
        this.selectedItems = []
      }
    },
    generateAllItems() {
      // eslint-disable-next-line eqeqeq
      return this.table_data.filter(item => item.upload_status != 1)
    },
    async downloadMaterial() {
      var videoUrls = this.selectedItems.map(item => item.video_url)
      for (let i = 0; i < videoUrls.length; i++) {
        const url = videoUrls[i]
        try {
          const response = await fetch(url)
          const blob = await response.blob()
          const blobUrl = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.href = blobUrl
          a.download = `video_${i + 1}.mp4`
          a.click()

          setTimeout(() => {
            URL.revokeObjectURL(blobUrl) // 释放内存
          }, 100)
        } catch (error) {
          console.error(`下载失败: ${url}`, error)
        }
      }
    },
    handleChange(val) {
      if (val === 'all') {
        this.query.iaa = null
        this.query.iap = null
      } else if (val === 'iaa') {
        this.query.iaa = 2
        this.query.iap = 0
      } else if (val === 'iap') {
        this.query.iaa = 0
        this.query.iap = 2
      }
    }
    // checkSlot(val) {
    //   console.log(val)
    //   if (this.slot_value === val) {
    //     this.slot_value = null
    //   } else {
    //     this.slot_value = val
    //   }
    //   this.query.sort = this.slot_value ? this.slot_value.value : null
    //   this.list()
    // }
  }
}
</script>

<style scoped>

.line {
  height: 1px;
  background: #e5e6eb;
  margin-top: 1px;
}
.search-container {
  display: flex;
  width: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
.search-input {
  flex: 1;
  border: none;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
}

.search-button {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.sticky-header {
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
  position: sticky;
  top: 85px;
  z-index: 999;
  border: 1px solid rgb(240, 242, 245);
}
</style>
